<template>
  <span>
    <el-popover ref="popover" v-model="popoverVisible" placement="bottom" width="250" trigger="click">
      <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
        <el-form-item prop="datetime">
          <el-date-picker
            size="small"
            v-model="form.datetime"
            type="datetime"
            :picker-options="pickerOptions"
            placeholder="Select date and time"
          />
        </el-form-item>
        <el-button native-type="submit" size="small" type="primary" :loading="loading">
          Save
        </el-button>
      </el-form>
    </el-popover>
    <el-button size="mini" type="primary" v-popover:popover>
      Schedule
    </el-button>
  </span>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    newsletterId: String,
    publishedAt: Date,
  },

  data() {
    return {
      loading: false,
      popoverVisible: false,
      form: {
        datetime: this.publishedAt,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < moment()
        },
      },
      rules: {
        'datetime': [
          { required: true, message: 'Select a date and time.', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) return false

        this.loading = true

        try {
          var { data } = await this.$http.put(`/newsletters/${ this.newsletterId }`, {
            publishedAt: this.form.datetime,
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.$message.success('Newsletter has been updated.')
        this.popoverVisible = false
        this.$emit('update')
      })
    },
  },
}
</script>
